import { render, staticRenderFns } from "./star.vue?vue&type=template&id=d1dc50b8&scoped=true"
import script from "./star.vue?vue&type=script&lang=js"
export * from "./star.vue?vue&type=script&lang=js"
import style0 from "./star.vue?vue&type=style&index=0&id=d1dc50b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dc50b8",
  null
  
)

export default component.exports